'use client';
import type { XYChartPreviewSeries } from './xychart-compact-preview-model';
export interface XYChartBarSparkProps {
    stepX: number;
    focusSeries: XYChartPreviewSeries;
    categoryLabels: string[];
    xPositionFor: (index: number) => number;
    yPositionFor: (value: number) => number;
    zeroY: number;
    trendColor: string;
}
const BAR_SPARK_POINT_NAME = 'sparkBar';
const BAR_SPARK_LATEST_MARKER_NAME = 'latestSparkMarker';
const BAR_SPARK_GROUP_NAME = 'sparkBarGroup';
function getPointIdentity(input: {
    categoryLabel: string | undefined;
    seriesLabel: string;
    value: number;
}): string {
    if (input.categoryLabel) {
        return `${input.seriesLabel}-${input.categoryLabel}`;
    }
    return `${input.seriesLabel}-uncategorized-value-${input.value}`;
}
export function XYChartBarSpark({ stepX, focusSeries, categoryLabels, xPositionFor, yPositionFor, zeroY, trendColor, }: XYChartBarSparkProps) {
    const barWidth = Math.max(4, Math.min(18, stepX * 0.5));
    const latestIndex = focusSeries.data.length - 1;
    return (
      <g>
      {focusSeries.data.map((value, index) => {
            const py = yPositionFor(value);
            const top = Math.min(py, zeroY);
            const heightPx = Math.max(1, Math.abs(zeroY - py));
            const cx = xPositionFor(index) - barWidth / 2;
            const isLatest = index === latestIndex;
            const opacity = 0.3 + 0.7 * (index / Math.max(1, latestIndex));
            const pointIdentity = getPointIdentity({
                categoryLabel: categoryLabels[index],
                seriesLabel: focusSeries.label,
                value,
            });
            return (<g key={`spark-bar-${pointIdentity}`}>
            <rect x={cx} y={top} width={barWidth} height={heightPx} rx={barWidth / 2} fill={trendColor} opacity={opacity}/>
            {isLatest && (<circle cx={cx + barWidth / 2} cy={Math.max(10, top - 12)} r={4} fill="#ffffff" stroke={trendColor} strokeWidth={1.5}/>)}
          </g>);
        })}
    </g>
    );
}
